export default __webpack_public_path__ + "media/images/features/ana/tottori_prefecture-f0937bd0e9b955cf7f427f295e16967f.png";